/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AvailableDexesResponse,
  GetPoolsByDexParams,
  PoolsResponse
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAvailableDexesUrl = () => {




  return `/api/dexes`
}

export const getAvailableDexes = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<AvailableDexesResponse> => {

  return arbBotFetcher<AvailableDexesResponse>(getGetAvailableDexesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAvailableDexesQueryKey = () => {
    return [
    `/api/dexes`
    ] as const;
    }


export const getGetAvailableDexesQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableDexes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableDexesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableDexes>>> = ({ signal }) => getAvailableDexes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableDexesQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableDexes>>>
export type GetAvailableDexesQueryError = unknown


export function useGetAvailableDexes<TData = Awaited<ReturnType<typeof getAvailableDexes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableDexes>>,
          TError,
          Awaited<ReturnType<typeof getAvailableDexes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDexes<TData = Awaited<ReturnType<typeof getAvailableDexes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableDexes>>,
          TError,
          Awaited<ReturnType<typeof getAvailableDexes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDexes<TData = Awaited<ReturnType<typeof getAvailableDexes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableDexes<TData = Awaited<ReturnType<typeof getAvailableDexes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDexes>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableDexesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPoolsByDexUrl = (dex: string,
    params?: GetPoolsByDexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pools/${dex}?${stringifiedParams}` : `/api/pools/${dex}`
}

export const getPoolsByDex = async (dex: string,
    params?: GetPoolsByDexParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<PoolsResponse> => {

  return arbBotFetcher<PoolsResponse>(getGetPoolsByDexUrl(dex,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPoolsByDexQueryKey = (dex: string,
    params?: GetPoolsByDexParams,) => {
    return [
    `/api/pools/${dex}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPoolsByDexQueryOptions = <TData = Awaited<ReturnType<typeof getPoolsByDex>>, TError = unknown>(dex: string,
    params?: GetPoolsByDexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPoolsByDexQueryKey(dex,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPoolsByDex>>> = ({ signal }) => getPoolsByDex(dex,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: dex !== null && dex !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPoolsByDexQueryResult = NonNullable<Awaited<ReturnType<typeof getPoolsByDex>>>
export type GetPoolsByDexQueryError = unknown


export function useGetPoolsByDex<TData = Awaited<ReturnType<typeof getPoolsByDex>>, TError = unknown>(
 dex: string,
    params: undefined |  GetPoolsByDexParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPoolsByDex>>,
          TError,
          Awaited<ReturnType<typeof getPoolsByDex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPoolsByDex<TData = Awaited<ReturnType<typeof getPoolsByDex>>, TError = unknown>(
 dex: string,
    params?: GetPoolsByDexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPoolsByDex>>,
          TError,
          Awaited<ReturnType<typeof getPoolsByDex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPoolsByDex<TData = Awaited<ReturnType<typeof getPoolsByDex>>, TError = unknown>(
 dex: string,
    params?: GetPoolsByDexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPoolsByDex<TData = Awaited<ReturnType<typeof getPoolsByDex>>, TError = unknown>(
 dex: string,
    params?: GetPoolsByDexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPoolsByDex>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPoolsByDexQueryOptions(dex,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






